<template>
  <div id="app">
    <router-view :key="$route.name"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{}
  },
  computed:{},
  created(){},
  mounted() {
  },
  methods:{
  },
}
</script>
